import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';
import Leaders from '@mindful-web/marko-web-leaders/browser';

const PrestitialCookie = () => import(/* webpackChunkName: "global-prestitial-cookie" */ './prestitial-cookie.vue');
const SuperstitialCookie = () => import(/* webpackChunkName: "global-superstitial-cookie" */ './superstitial-cookie.vue');
const BBMForm = () => import(/* webpackChunkName: "bbm-form" */ './bbm-form.vue');
const BBMNewsletterForm = () => import(/* webpackChunkName: "bbm-newsletter-form" */ './bbm-newsletter-form.vue');
const GlobalNodeCarousel = () => import(/* webpackChunkName: "global-node-carousel" */ './node-carousel.vue');
const OOPAdHandler = () => import('./oop-ad-handler.vue');
const GlobalToaster = () => import('./toaster.vue');

export default (Browser) => {
  MonoRail(Browser);
  Leaders(Browser);
  Browser.register('GlobalPrestitialCookie', PrestitialCookie);
  Browser.register('GlobalSuperstitialCookie', SuperstitialCookie);
  Browser.register('BBMForm', BBMForm);
  Browser.register('BBMNewsletterForm', BBMNewsletterForm);
  Browser.register('GlobalNodeCarousel', GlobalNodeCarousel);
  Browser.register('GlobalOOPAdHandler', OOPAdHandler);
  Browser.register('GlobalToaster', GlobalToaster);
};
